<template>
    <div class="container">
      <!-- Login Tab Content -->
            <div class="row mt-5 justify-content-center">
              <div class="col-md-6 col-12 pl-md-5" :style="{ marginTop: domain_for_data === 'Hospital Portal' ? '120px' : '50px' }">
                <h1 style="font-size: 42px;">{{ hero_Page_heading }}</h1>
                <h3 style="font-size: 27px;">{{ hero_page_sub_heading }}</h3>
                <div class="mt-4 button">
                  <div v-if="!isUserDataEmpty && !isHospitalPortal">
                    <router-link :to="main_content.button.link">
                      <button class="btn btn-danger"> {{ main_content.button.label }}</button>
                     
                    </router-link>
                  </div>

                  <div v-if="!isUserDataEmpty">
                    <router-link :to="main_content.button1.link">
                      <button class="btn btn-primary ml-2">{{ main_content.button1.label }}</button>
                    </router-link>
                  </div>
                </div>
              </div>
              <div class="col-md-5 col-12">
                <img :src="'https://develop-physio.kneexpert.in' + loginPageImage" class="img-fluid_main" alt="Login Banner"
                  loading="lazy" :style="{ display: loginPageImage ? 'block' : 'none' }" style="max-width: 500px; max-height: 500px;"/>
                  <!-- <img src="../../assets/img/doctors/doctor.png" class="img-fluid_main" alt="Login Banner"
                  loading="lazy" :style="{ display: loginPageImage ? 'block' : 'none' }" style="max-width: 500px; max-height: 500px;" /> -->
              </div>


              <!-- <div class="col-md-6 col-lg-6 mt-2">
                <h2 class="right_heading">{{ hero_Page_heading }}</h2>
                <h4 class="right_content_data">{{ hero_page_sub_heading }}</h4>
                <div class="mt-4 button">
                  <div v-if="!isUserDataEmpty && !isHospitalPortal">
                    <router-link class="btn btn-secondary" :to="main_content.button.link"
                      style="background: #d01209 !important;font-size: 15px;">
                      {{ main_content.button.label }}
                    </router-link>
                  </div>

                  <div v-if="!isUserDataEmpty">
                    <router-link class="btn btn-secondary ml-2" :to="main_content.button1.link"
                      style="background:rgb(60, 179, 113) !important;font-size: 15px;">
                      {{ main_content.button1.label }}
                    </router-link>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-lg-6 mt-4 mt-md-0">
                <img :src="'https://develop-physio.kneexpert.in' + loginPageImage" class="img-fluid_main" alt="Login Banner"
                  loading="lazy" :style="{ display: loginPageImage ? 'block' : 'none' }" />

              </div> -->
            </div>
      <div class="mt-5">
        <h4 class="right_content pb-3" align="center">
          <h2 style="font-weight: bold; ">Your Health at Your Fingertips</h2>
          <h5>Accessibility, Transparency, and Empowerment</h5>
        </h4>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-md-6 col-lg-3 col-sm-12 col-12 mt-4">
            <div class="hospital-card-container">
              <div class="hospital-card">
                <div class="heading"
                  style="font-size: 17px; background-color: cadetblue; height: 80px; color:white; padding-top:25px; text-align: center;">
                  Patient Portal</div>
                <div class="description" style="height: 170px;">
                  <p class="p-2" style="font-size: 16px;">A dedicated online hub for patients to manage their medical
                    journey.
                    Book appointments, access prescriptions, view medical history, and
                    communicate with healthcare professionals.</p>
                </div>
                <div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-3 col-sm-12 col-12 mt-4">
            <div class="hospital-card-container">
              <div class="hospital-card">
                <div class="heading"
                  style="font-size: 17px; background-color: cadetblue; height: 80px; color:white;padding-top:25px; text-align: center;">
                  Online Appointment Booking</div>
                <div class="description" style="height: 170px;">
                  <p class="p-2" style="font-size: 16px;">Book appointments with preferred healthcare professionals easily
                    from
                    the comfort of home. View real-time availability and choose time slots
                    that suit best.</p>
                </div>
                <div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-3 col-sm-12 col-12 mt-4">
            <div class="hospital-card-container">
              <div class="hospital-card">
                <div class="heading p-1"
                  style="font-size: 17px; background-color: cadetblue; height: 80px; color:white; text-align: center;">
                  Digital Storage and Management of Medical Records and Vital Signs
                </div>
                <div class="description" style="height: 170px;">
                  <p class="p-2" style="font-size: 16px;">In the age of digital transformation, accessing and managing a
                    patient's medical records and
                    vital
                    signs shouldn't require sifting through piles of paperwork.</p>
                </div>
                <div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-3 col-sm-12 col-12 mt-4">
            <div class="hospital-card-container">
              <div class="hospital-card">
                <div class="heading p-1"
                  style="font-size: 17px; background-color: cadetblue; height: 80px; color:white; text-align: center;">
                  Automated Patient Encounter Documentation & Analysis
                </div>
                <div class="description" style="height: 170px;">
                  <p class="p-2" style="font-size: 16px;">Every interaction with healthcare professionals gets
                    automatically
                    documented. This ensures a comprehensive record of the patient's
                    healthcare journey</p>
                </div>
                <div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-5" v-if="!isHospitalPortal">
        <h4 class="right_content pb-3" align="center">
          <h2 style="font-weight: bold; ">
            {{ hero_Page_heading }}
          </h2>
          <h5>
            {{ hero_page_sub_heading }}
          </h5>
        </h4>
      </div>

      <div class="mt-5 mb-3" v-if="!isHospitalPortal">
        <b-tabs active-nav-item-class="font-weight-bold text-white bg-success" content-class="mt-3" align="center">
          <b-card-group deck>
            <b-tab title="For Doctor" active>
              <div class="container">
                <div class="row">
                  <div class="col-md-6 col-lg-3 col-sm-12 col-12">
                    <div class="hospital-card-container">
                      <div class="hospital-card">
                        <div class="heading p-1"
                          style="font-size: 17px; background-color: cadetblue; height: 65px; color:white; text-align: center;">
                          Complaint Analysis and Diagnosis Workflow</div>
                        <div class="description" style="height: 130px;">
                          <p class="p-2" style="font-size: 16px;">Structured logging and analysis of patient complaints
                            lead to precise diagnoses and effective treatment plans.</p>
                        </div>
                        <div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-3 col-sm-12 col-12 ">
                    <div class="hospital-card-container">
                      <div class="hospital-card">
                        <div class="heading p-1"
                          style="font-size: 17px; background-color: cadetblue; height: 65px; color:white; text-align: center;">
                          Treatment Plan Templates for Speed and Accuracy</div>
                        <div class="description" style="height: 130px;">
                          <p class="p-2" style="font-size: 16px;">Create and store treatment plan templates and Reuse for
                            patients with similar conditions.</p>
                        </div>
                        <div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-3 col-sm-12 col-12 ">
                    <div class="hospital-card-container">
                      <div class="hospital-card">
                        <div class="heading p-1"
                          style="font-size: 17px; background-color: cadetblue; height: 65px; color:white; text-align: center;">
                          Prescription Slip Automation and Sharing
                        </div>
                        <div class="description" style="height: 130px;">
                          <p class="p-2" style="font-size: 16px;">Simplify prescriptions generation , ensuring accuracy
                            and saving valuable time.</p>
                        </div>
                        <div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-3 col-sm-12 col-12">
                    <div class="hospital-card-container">
                      <div class="hospital-card">
                        <div class="heading p-1"
                          style="font-size: 17px; background-color: cadetblue; height: 65px; color:white; text-align: center;">
                          Digital Storage of Medical Records and Vital Signs
                        </div>
                        <div class="description" style="height: 130px;">
                          <p class="p-2" style="font-size: 16px;">Manage medical records and vital signs digitally,
                            ensuring all patient information is at your fingertips.</p>
                        </div>
                        <div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
            <b-tab title="For Hospital">
              <div class="container">
                <div class="row">
                  <div class="col-md-6 col-lg-3 col-sm-12 col-12">
                    <div class="hospital-card-container">
                      <div class="hospital-card">
                        <div class="heading p-1"
                          style="font-size: 17px; background-color: cadetblue; height: 65px; color:white; text-align: center;">
                          Schedule Time slots across Multiple Hospitals</div>
                        <div class="description" style="height: 130px;">
                          <p class="p-2" style="font-size: 16px;">Facilitates defining schedules across different hospitals / locations seamlessly.</p>
                        </div>
                        <div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-3 col-sm-12 col-12 ">
                    <div class="hospital-card-container">
                      <div class="hospital-card">
                        <div class="heading p-1"
                          style="font-size: 17px; background-color: cadetblue; height: 65px; color:white; text-align: center;">
                          Integration with External Healthcare Systems</div>
                        <div class="description" style="height: 130px;">
                          <p class="p-2" style="font-size: 16px;">Easily integrate with various external healthcare systems.</p>
                        </div>
                        <div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-3 col-sm-12 col-12 ">
                    <div class="hospital-card-container">
                      <div class="hospital-card">
                        <div class="heading p-1"
                          style="font-size: 17px; background-color: cadetblue; height: 65px; color:white; text-align: center;">
                          Collaboration Tools for Interdisciplinary Care
                        </div>
                        <div class="description" style="height: 130px;">
                          <p class="p-2" style="font-size: 16px;">Enables Sharing patient medical records to Patients / Other Doctors.</p>
                        </div>
                        <div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-3 col-sm-12 col-12">
                    <div class="hospital-card-container">
                      <div class="hospital-card">
                        <div class="heading p-1"
                          style="font-size: 17px; background-color: cadetblue; height: 65px; color:white; text-align: center;">
                          Integrated Patient Feedback and Review System
                        </div>
                        <div class="description" style="height: 130px;">
                          <p class="p-2" style="font-size: 16px;">Capture and analyze feedback from patients to continually improve hospital services.</p>
                        </div>
                        <div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
          </b-card-group>
        </b-tabs>
      </div>
    </div>
</template>
<script>
import axios from "axios";
import config from "../../services/CommonApi";
export default {
  data() {
    return {
      domain_for_data:"",
      config: config,
      hero_Page_heading: "",
      hero_page_sub_heading: "",
      user_data: "",
      loginPageImage: "",
      isHospitalPortal: false,
      main_content: {
        button: {
          label: "Register as Doctor",
          link: "/doctor/register",
        },
        button1: {
          label: "Register as Patient",
          link: "/patient/register",
        },
        button2: {
          label: "Complain",
          link: "/complain",
        },

      },
      tabs: [
        {
          title: "For Hospitals",
          section_heading: "Empowering Hospitals with Smart Solutions",
          section_subheading:
            "Streamlined Management, Collaboration, and Efficiency",
          cards: [
            {
              header: "Schedule Time slots across Multiple Hospitals",
              text:
                "Facilitates defining schedules across different hospitals / locations seamlessly.",
            },
            {
              header: "Integration with External Healthcare Systems",
              text:
                "Easily integrate with various external healthcare systems.",
            },
            {
              header: "Collaboration Tools for Interdisciplinary Care",
              text:
                "Enables Sharing patient medical records to Patients / Other Doctors",
            },
            {
              header: "Integrated Patient Feedback and Review System",
              text:
                "Capture and analyze feedback from patients to continually improve hospital services.",
            },
          ],
        },
      ],
    };
  },

  mounted() {
    this.get_practitioner_profile();
    const userInfo = JSON.parse(localStorage.getItem('userInfo'))
    if (userInfo && userInfo.username) {
      this.user_data = userInfo.username;
      console.log(this.user_data)
    } else {
      console.error("userinfo undefined");
    }
  },

  computed: {
    isUserDataEmpty() {
      return this.user_data;
    },
  },

  methods: {


    async get_practitioner_profile() {
      var domain = window.location.hostname;

      const formdata = {
        domain: window.location.hostname,
      };
      await axios
        .get(
          "https://develop-physio.kneexpert.in/api/method/sahaj.domain.get_hospital?domain=" +
          window.location.hostname
        )
        .then((res) => {
          this.showspinner = false;
          if (res.data.status_code == 200) {
            this.loginPageImage = res.data.data[0].home_image;
            this.hero_Page_heading = res.data.data[0].home_page_line;
            this.hero_page_sub_heading = res.data.data[0].home_page_sub_line;
            this.domain_for_data = res.data.data[0].domain_for;
            if (res.data.data[0].domain_for === "Hospital Portal") {
              this.isHospitalPortal = true;
            }

          }
          if (res.data.status_code == 404) {
            if (window.location.hostname == "physio.sahajhelp.com") {
            } else if (window.location.hostname == "physio.kneexpert.in") {
            } else if (window.location.hostname == "localhost") {
            }
            else if (window.location.hostname.startsWith("192.168")) {
            } else if (window.location.hostname == "iitb.smartyhealthcare.in") {
            } else {
              window.location.href = String("https://physio.kneexpert.in");
            }
          }

          this.$swal.close();
        });
    },


    getImagePath(imgName) {
      return require("@/assets/img/" + imgName);
    },
  },
};
</script>

<style>
/* Default styles for all screen sizes */


.button {
  display: flex;
  flex-direction: row;
}


.accordion-row {
  display: flex;
  flex-direction: row;
}

.accordion-item {
  flex: 1;
  margin-right: 10px;
  /* Adjust as needed */
}


.hospital-card-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  /* Centers the cards horizontally */
  gap: 20px;
  margin: 30px auto;
  /* 30px margin on top and bottom, auto centers the container */
  max-width: 100%;
  /* Adjust as needed to control the container width */
}

.hospital-card {
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  width: 100%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  /* Centers the content inside the card */
}</style>


// WEBPACK FOOTER //
// src/components/kneexpert/MainHome.vue